import React, { useEffect } from "react";
import { DataBox } from "./DataBox";
import { DetailDrawer } from "./DetailDrawer";
import { PageHeader } from "./PageHeader";
import { orgService } from "../../org/orgService";
import { useShopModel } from "../shopModel";
import { dictService } from "../../dict/dictService";
import { DictCodeEnmu } from "@/types/FmsDictEnums";
import { beService } from "../../be/beService";

export function OrganizaShop() {
    const { setOrgDs, setShopTypeDs, setBeDs } = useShopModel();

    useEffect(() => {
        orgService.orgTreeDs({}).then(ds => setOrgDs(ds))
        dictService.dictItemDs(DictCodeEnmu.SHOP_TYPE).then(ds => setShopTypeDs(ds));
        beService.beDs({}).then(ds => setBeDs(ds))
    }, []);

    return (
        <>
            <PageHeader />
            <DataBox />
            <DetailDrawer />
        </>
    );
}

